document.addEventListener('DOMContentLoaded', initStoriesEcosystem)
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.stories-ecosystem')) initStoriesEcosystem()
})

function initStoriesEcosystem() {
  if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') return

  const section = document.querySelector('.stories-ecosystem')
  if (!section) return

  const dataScript = document.getElementById(
    `EcosystemData-${section.dataset.sectionId}`,
  )
  if (!dataScript) return

  const ecosystemData = JSON.parse(dataScript.textContent)
  const categories = ecosystemData.categories
  const allMedia = ecosystemData.media
  if (categories.length === 0) return

  const track = section.querySelector('[data-gsap="bento-track"]')
  const filterContainer = section.querySelector('[data-gsap="bento-filters"]')
  const viewport = section.querySelector('.bento-viewport')

  // --- ENGINE VARIABLES ---
  let trackX = 0
  let speedMultiplier = 1
  let isDraggingTrack = false
  let isModalOpen = false
  let isJumping = false
  let jumpLock = false
  let firstActiveIndex = 0
  let lastActiveIndex = 0
  let currentCategoryIndex = -1
  let resizeTimer = null
  let handleResize = null
  let currentModalItems = []
  let currentModalIndex = -1
  let handleKeyDown = null

  // Measure header height dynamically to position the modal exactly beneath the navigation bar
  const measureHeader = () => {
    const header = document.querySelector('.header-wrapper') || document.querySelector('header') || document.querySelector('[class*="header"]')
    const height = header ? header.getBoundingClientRect().height : 80
    document.documentElement.style.setProperty('--header-height', `${height}px`)
  }
  measureHeader()
  window.addEventListener('resize', measureHeader)

  // --- HELPER: Update Buttons ---
  function updateActiveButton(index) {
    if (currentCategoryIndex === index) return
    currentCategoryIndex = index
    section.querySelectorAll('.filter-btn').forEach((btn, i) => {
      btn.classList.toggle('is-active', i === index)
    })
  }

  // --- 1. HERO CARDS (Responsive Span & Zig-Zag) ---
  const photos = gsap.utils.toArray(
    section.querySelectorAll('[data-gsap="story-photo"]'),
  )

  if (photos.length > 0) {
    const calculateSpreadMultiplier = () => {
      const screenWidth = window.innerWidth
      const baseSpan = 640
      let multiplier = Math.min(1, Math.max(0.1, (screenWidth - 40) / baseSpan))

      if (screenWidth < 768) return multiplier * 0.4
      if (screenWidth < 1024) return multiplier * 0.85
      return multiplier
    }

    const getResponsiveY = (index, targetY, multiplier) => {
      if (window.innerWidth < 768) return index % 2 === 0 ? 35 : -35
      return parseFloat(targetY) * multiplier
    }

    const currentMultiplier = calculateSpreadMultiplier()

    photos.forEach((photo, i) => {
      photo.dataset.restX =
        parseFloat(photo.dataset.targetX) * currentMultiplier
      photo.dataset.restY = getResponsiveY(
        i,
        photo.dataset.targetY,
        currentMultiplier,
      )
      photo.dataset.restRot = (Math.random() * 3 + 1) * (i < 2 ? -1 : 1)
      photo.dataset.origZ = 50 - i
    })

    gsap.fromTo(
      photos,
      { autoAlpha: 0, scale: 0.5 },
      {
        autoAlpha: 1,
        scale: 1,
        duration: 0.6,
        ease: 'back.out(1.5)',
        onComplete: () => {
          gsap.to(photos, {
            x: (i, t) => t.dataset.restX,
            y: (i, t) => t.dataset.restY,
            rotation: (i, t) => t.dataset.restRot,
            duration: 1.2,
            stagger: 0.1,
            ease: 'elastic.out(1, 0.75)',
          })
        },
      },
    )

    Draggable.create(photos, {
      type: 'x,y',
      edgeResistance: 0.65,
      onPress: function () {
        gsap.to(this.target, {
          scale: 1.1,
          zIndex: 999,
          boxShadow: '0px 15px 40px rgba(255, 215, 0, 0.8)',
          duration: 0.3,
          overwrite: 'auto',
        })
      },
      onRelease: function () {
        gsap.to(this.target, {
          x: this.target.dataset.restX,
          y: this.target.dataset.restY,
          scale: 1,
          rotation: this.target.dataset.restRot,
          zIndex: this.target.dataset.origZ,
          boxShadow: 'none',
          duration: 0.8,
          ease: 'elastic.out(1, 0.6)',
          overwrite: 'auto',
        })
      },
      onClick: function () {
        const index = categories.findIndex(
          (c) => c.id === this.target.dataset.categoryId,
        )
        if (index !== -1) jumpToCategory(index)
      },
    })

    photos.forEach((photo) => {
      photo.addEventListener('mouseenter', () => {
        if (!Draggable.get(photo)?.isDragging)
          gsap.to(photo, {
            scale: 1.05,
            zIndex: 99,
            boxShadow: '0px 10px 30px rgba(255,215,0,0.6)',
            duration: 0.3,
            overwrite: 'auto',
          })
      })
      photo.addEventListener('mouseleave', () => {
        if (!Draggable.get(photo)?.isDragging)
          gsap.to(photo, {
            scale: 1,
            zIndex: photo.dataset.origZ,
            boxShadow: 'none',
            duration: 0.3,
            overwrite: 'auto',
          })
      })
    })

    handleResize = () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        const newMultiplier = calculateSpreadMultiplier()
        photos.forEach((photo, i) => {
          photo.dataset.restX =
            parseFloat(photo.dataset.targetX) * newMultiplier
          photo.dataset.restY = getResponsiveY(
            i,
            parseFloat(photo.dataset.targetY),
            newMultiplier,
          )

          if (!Draggable.get(photo)?.isDragging) {
            gsap.to(photo, {
              x: photo.dataset.restX,
              y: photo.dataset.restY,
              duration: 0.6,
              ease: 'power3.out',
              overwrite: 'auto',
            })
          }
        })
      }, 200)
    }
    window.addEventListener('resize', handleResize)
  }

  // --- 2. FILTER BUTTONS ---
  filterContainer.innerHTML = ''
  categories.forEach((cat, index) => {
    const btn = document.createElement('button')
    btn.className = 'filter-btn'
    btn.textContent = cat.title
    btn.addEventListener('click', () => {
      if (currentCategoryIndex !== index) jumpToCategory(index)
    })
    filterContainer.appendChild(btn)
  })

  // --- 3. TRUE INFINITE CAROUSEL LOGIC ---
  function createCard(item, index, mediaToRender) {
    const card = document.createElement('div')
    card.className = `bento-card ${item.span}`

    // Inject IDs for the pop-up to read later
    card.dataset.categoryIndex = index
    card.dataset.mediaId = item.id

    card.innerHTML =
      item.type === 'video'
        ? `<video class="bento-card-media" src="${item.url}" muted loop playsinline></video>`
        : `<img class="bento-card-media" src="${item.url}" alt="${item.title}" loading="lazy">`
    card.innerHTML += `<div class="bento-card-info"><h3>${item.title}</h3><p>${item.desc}</p></div>`

    card
      .querySelector('video')
      ?.play()
      .catch(() => {})

    return card
  }

  function addCategoryNodes(index, position = 'append') {
    const activeCategory = categories[index]
    const mediaToRender = allMedia.filter(
      (m) => m.category === activeCategory.id,
    )
    const frag = document.createDocumentFragment()

    if (position === 'append') {
      if (track.children.length > 0) {
        const spacer = document.createElement('div')
        spacer.className = 'bento-spacer'
        frag.appendChild(spacer)
      }
      mediaToRender.forEach((item) =>
        frag.appendChild(createCard(item, index, mediaToRender)),
      )
      track.appendChild(frag)
    } else {
      mediaToRender.forEach((item) =>
        frag.appendChild(createCard(item, index, mediaToRender)),
      )
      if (track.children.length > 0) {
        const spacer = document.createElement('div')
        spacer.className = 'bento-spacer'
        frag.appendChild(spacer)
      }

      const oldWidth = track.scrollWidth
      track.prepend(frag)

      const newWidth = track.scrollWidth

      trackX -= newWidth - oldWidth
      gsap.set(track, { x: trackX })
      if (track._draggable && track._draggable[0]) track._draggable[0].update()
    }
  }

  function checkInfiniteBounds() {
    if (Math.abs(trackX) + viewport.clientWidth + 1500 > track.scrollWidth) {
      lastActiveIndex = (lastActiveIndex + 1) % categories.length
      addCategoryNodes(lastActiveIndex, 'append')
    }
    if (trackX > -500) {
      firstActiveIndex =
        (firstActiveIndex - 1 + categories.length) % categories.length
      addCategoryNodes(firstActiveIndex, 'prepend')
    }
  }

  // --- SEPARATED FUNCTION 1: Button Clicks ---
  function jumpToCategory(index) {
    if (jumpLock) return
    jumpLock = true
    isJumping = true
    updateActiveButton(index)
    gsap.ticker.remove(engineTick)

    gsap.to(track.children, {
      x: -30,
      opacity: 0,
      duration: 0.2,
      stagger: 0.01,
      onComplete: () => {
        track.innerHTML = ''
        trackX = 0
        gsap.set(track, { x: 0 })

        firstActiveIndex = (index - 1 + categories.length) % categories.length
        lastActiveIndex = index

        addCategoryNodes(firstActiveIndex, 'append')
        addCategoryNodes(lastActiveIndex, 'append')

        lastActiveIndex = (lastActiveIndex + 1) % categories.length
        addCategoryNodes(lastActiveIndex, 'append')

        const targetCards = track.querySelectorAll(
          `[data-category-index="${index}"]`,
        )

        if (targetCards.length > 0) {
          trackX = -targetCards[0].offsetLeft + 50
        } else {
          trackX = -500
        }

        gsap.set(track, { x: trackX })
        if (track._draggable && track._draggable[0]) {
          track._draggable[0].update()
        }

        gsap.fromTo(
          track.children,
          { x: 30, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 0.4,
            stagger: 0.02,
            ease: 'power2.out',
            onComplete: () => {
              gsap.ticker.add(engineTick)
              jumpLock = false
              setTimeout(() => {
                isJumping = false
              }, 50)
            },
          },
        )
      },
    })
  }

  // --- SEPARATED FUNCTION 2: Auto-Detect on Scroll ---
  function autoDetectCategory() {
    if (isJumping) return

    let detectedIndex = currentCategoryIndex
    const viewportRect = viewport.getBoundingClientRect()
    const triggerLine = viewportRect.left + viewportRect.width * 0.3

    for (let i = 0; i < track.children.length; i++) {
      const el = track.children[i]
      if (!el.classList.contains('bento-card')) continue

      const rect = el.getBoundingClientRect()
      if (rect.right > triggerLine) {
        detectedIndex = parseInt(el.dataset.categoryIndex)
        break
      }
    }

    if (!isNaN(detectedIndex) && detectedIndex !== currentCategoryIndex) {
      updateActiveButton(detectedIndex)
    }
  }

  // The Infinite Frame Engine
  function engineTick() {
    if (isModalOpen || jumpLock) return // Completely halts movement if modal is open

    if (isDraggingTrack) {
      trackX = gsap.getProperty(track, 'x')
    } else {
      trackX -= 0.8 * speedMultiplier
      gsap.set(track, { x: trackX })
    }

    checkInfiniteBounds()
    autoDetectCategory()
  }

  // --- 4. TRACK INTERACTION & CLICK DETECTION ---
  if (track._draggable) track._draggable[0].kill()
  track._draggable = Draggable.create(track, {
    type: 'x',
    dragClickables: true,
    onPress: function () {
      speedMultiplier = 5
    },
    onDragStart: function () {
      isDraggingTrack = true
      speedMultiplier = 1
    },
    onRelease: function () {
      isDraggingTrack = false
      speedMultiplier = 0.2
    },
    onClick: function (e) {
      // Find the card that was clicked, no matter what child element (image, text) was tapped
      const card = e.target.closest('.bento-card')
      if (!card) return

      const categoryIndex = parseInt(card.dataset.categoryIndex)
      const mediaId = card.dataset.mediaId

      if (mediaId !== undefined) {
        // Match the specific item to open in the pop-up from ALL media items
        const selectedItem = allMedia.find(
          (m) => String(m.id) === String(mediaId),
        )

        if (selectedItem) {
          openModal(selectedItem, allMedia)
        }
      }
    },
  })

  viewport.addEventListener('mouseenter', () => {
    if (!isDraggingTrack) speedMultiplier = 0.2
  })
  viewport.addEventListener('mouseleave', () => {
    if (!isDraggingTrack) speedMultiplier = 1
  })

  // --- 5. MODAL (POP-UP) LOGIC ---
  const modal = section.querySelector('[data-gsap="bento-modal"]')

  // Safety check: Ensure the modal HTML exists before trying to open it
  if (!modal) {
    console.warn('Bento Modal HTML not found in the DOM.')
    return
  }

  // Move the modal to document.body to prevent parent container transform/z-index issues.
  // This keeps the modal fixed in the visual viewport no matter where the section is.
  document.body.appendChild(modal)

  const modalContent = modal.querySelector('[data-gsap="modal-content"]')
  const mainMedia = modal.querySelector('[data-gsap="modal-main-media"]')
  const dockTrack = modal.querySelector('.modal-dock-track')
  const modalBackdrop = modal.querySelector('.bento-modal-backdrop')

  function showModalItem(index) {
    if (index < 0 || index >= currentModalItems.length) return
    currentModalIndex = index
    const dItem = currentModalItems[index]

    if (dockTrack) {
      const dockItems = dockTrack.querySelectorAll('.dock-item')
      dockItems.forEach((el, idx) => {
        el.classList.toggle('is-active', idx === index)
      })
    }

    if (mainMedia) {
      gsap.to(mainMedia, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          mainMedia.innerHTML =
            dItem.type === 'video'
              ? `<video src="${dItem.url}" autoplay loop muted playsinline></video>`
              : `<img src="${dItem.url}">`
          const titleEl = modal.querySelector('.modal-title')
          const descEl = modal.querySelector('.modal-desc')
          if (titleEl) titleEl.textContent = dItem.title
          if (descEl) descEl.textContent = dItem.desc
          gsap.to(mainMedia, { opacity: 1, duration: 0.3 })
        },
      })
    }
  }

  function openModal(item, categoryDataset) {
    isModalOpen = true // Signals engineTick to pause
    currentModalItems = categoryDataset
    currentModalIndex = categoryDataset.findIndex((m) => String(m.id) === String(item.id))

    // HARD FREEZE the draggable track so the carousel can't slide behind the pop-up
    if (track._draggable && track._draggable[0]) {
      track._draggable[0].disable()
    }

    if (mainMedia) {
      mainMedia.innerHTML =
        item.type === 'video'
          ? `<video src="${item.url}" autoplay loop muted playsinline></video>`
          : `<img src="${item.url}" alt="${item.title}">`
    }

    const titleEl = modal.querySelector('.modal-title')
    const descEl = modal.querySelector('.modal-desc')
    if (titleEl) titleEl.textContent = item.title
    if (descEl) descEl.textContent = item.desc

    if (dockTrack) {
      dockTrack.innerHTML = ''
      categoryDataset.forEach((dItem, idx) => {
        const dockItem = document.createElement('div')
        dockItem.className = `dock-item ${dItem.id === item.id ? 'is-active' : ''}`
        dockItem.innerHTML =
          dItem.type === 'video'
            ? `<video src="${dItem.url}"></video>`
            : `<img src="${dItem.url}">`

        dockItem.addEventListener('click', () => {
          showModalItem(idx)
        })
        dockTrack.appendChild(dockItem)
      })
    }

    modal.classList.add('is-active')

    if (modalBackdrop) gsap.to(modalBackdrop, { opacity: 1, duration: 0.4 })
    if (modalContent) {
      gsap.fromTo(
        modalContent,
        { y: 50, scale: 0.98, opacity: 0 },
        {
          y: 0,
          scale: 1,
          opacity: 1,
          duration: 0.6,
          ease: 'back.out(1.5)',
        },
      )
    }
  }

  function closeModal() {
    if (modalContent) {
      gsap.to(modalContent, {
        y: 30,
        scale: 0.98,
        opacity: 0,
        duration: 0.3,
        ease: 'power2.in',
      })
    }

    if (modalBackdrop) gsap.to(modalBackdrop, { opacity: 0, duration: 0.3 })

    setTimeout(() => {
      modal.classList.remove('is-active')
      isModalOpen = false
      isDraggingTrack = false
      speedMultiplier = 1

      // UNFREEZE the draggable track so the carousel can move again
      if (track._draggable && track._draggable[0]) {
        track._draggable[0].enable()
      }
    }, 300)
  }

  const closeBtn = modal.querySelector('[data-gsap="modal-close"]')
  if (closeBtn) closeBtn.addEventListener('click', closeModal)
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal)

  const prevBtn = modal.querySelector('[data-gsap="modal-prev"]')
  const nextBtn = modal.querySelector('[data-gsap="modal-next"]')

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentModalIndex > 0) {
        showModalItem(currentModalIndex - 1)
      } else {
        showModalItem(currentModalItems.length - 1)
      }
    })
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (currentModalIndex < currentModalItems.length - 1) {
        showModalItem(currentModalIndex + 1)
      } else {
        showModalItem(0)
      }
    })
  }

  handleKeyDown = (e) => {
    if (!isModalOpen) return
    if (e.key === 'ArrowLeft') {
      if (currentModalIndex > 0) {
        showModalItem(currentModalIndex - 1)
      } else {
        showModalItem(currentModalItems.length - 1)
      }
    } else if (e.key === 'ArrowRight') {
      if (currentModalIndex < currentModalItems.length - 1) {
        showModalItem(currentModalIndex + 1)
      } else {
        showModalItem(0)
      }
    } else if (e.key === 'Escape') {
      closeModal()
    }
  }
  document.addEventListener('keydown', handleKeyDown)

  // Boot up
  jumpToCategory(0)

  // --- 6. UNLOAD CLEANUP ---
  const handleUnload = (e) => {
    if (e.target.contains(section)) {
      gsap.ticker.remove(engineTick)
      if (resizeTimer) clearTimeout(resizeTimer)
      if (handleResize) window.removeEventListener('resize', handleResize)
      if (handleKeyDown) document.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('resize', measureHeader)

      // Kill Draggables to release memory/event listeners
      photos.forEach((photo) => {
        const drg = Draggable.get(photo)
        if (drg) drg.kill()
      })
      if (track._draggable && track._draggable[0]) {
        track._draggable[0].kill()
      }

      // Remove modal from body during theme editor reload
      if (modal && modal.parentNode) {
        modal.parentNode.removeChild(modal)
      }

      document.removeEventListener('shopify:section:unload', handleUnload)
    }
  }
  document.addEventListener('shopify:section:unload', handleUnload)
}
